module.exports = __webpack_public_path__ + "static/media/justin_trudeau.bcd5fe38.png";